import { useEffect } from 'react';

interface PageOverlayLockOptions {
  /** Takes `main` and `footer` out of the tab order and pointer reach, for overlays that veil the page. */
  inert: boolean;
  /** Freezes body scrolling. Desktop overlays leave this off: hiding the scrollbar reflows the page. */
  lockScroll: boolean;
}

/**
 * Keeps page content behind an open overlay unreachable. Call it once per overlay owner with a
 * value that is only ever true for that owner, so two callers never disagree about the same nodes.
 */
export const usePageOverlayLock = ({ inert, lockScroll }: PageOverlayLockOptions) => {
  useEffect(() => {
    const main = document.querySelector('main');
    const footer = document.querySelector('footer');

    if (main != null) main.inert = inert;
    if (footer != null) footer.inert = inert;
  }, [inert]);

  useEffect(() => {
    document.body.style.overflow = lockScroll ? 'hidden' : 'unset';
  }, [lockScroll]);
};
